/**
 * @description 图片处理相关的函数集合
 * @author duanjun
 * @date
 */

import * as imageApi from '@umu/umu-image-handle';

export default imageApi;
